// extracted by mini-css-extract-plugin
export var buttons = "bl_cn";
export var container = "bl_b";
export var content = "bl_b6";
export var icon = "bl_bw";
export var iconContainer = "bl_b4";
export var image = "bl_k";
export var section = "bl_j";
export var selected = "bl_bg";
export var tab = "bl_fl";
export var tabText = "bl_fk";